import dataApi from '../'

export default {

  /**
   * Get mix info
   */
  getGet (uuid) {
    return dataApi.request({
      method: 'get',
      url: 'ui/mix/get/' + uuid
    })
  },

  /**
  * Get mixes that the given user is allowed to see
  */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/mix/overview',
      params: params
    })
  },

  /**
   * Get mixes for organization
   */
  getOverviewByOrganization (organizationUUID) {
    return dataApi.request({
      method: 'get',
      url: 'ui/mix/search/organization/' + organizationUUID
    })
  },

  /**
   * Get mixes by unit
   */
  getOverviewByUnit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/mix/overview-by-unit',
      params: params
    })
  },

  /**
  * Get mixes based on a search value
  */
  getSearch (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/mix/search',
      params: params
    })
  },

  /**
  * Delete mix
  */
  deleteDelete (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/mix/delete',
      params: params
    })
  },

  /**
  * Add mix
  */
  postAdd (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/mix/add',
      body: params
    })
  },

  /**
  * Edit mix
  */
  putEdit (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/mix/edit',
      body: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/mix.js